interface TabSwitchProps {
  tabs: { label: string; value: string }[]
  activeTab: string
  onChange: (value: string) => void
}

export default function TabSwitch({ tabs, activeTab, onChange }: TabSwitchProps) {
  return (
    <div className="bg-gray-100 rounded-full p-1 flex gap-1">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          type="button"
          className={`flex-1 px-6 py-2.5 rounded-full text-center text-base font-medium cursor-pointer transition-all ${
            activeTab === tab.value
              ? 'bg-white shadow-md text-black'
              : 'text-gray-400'
          }`}
          onClick={() => onChange(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
